import { PostMultiMediaAttachMode } from '../models/graphql';
import { EditorText, MediaTypePostEditorState, VariationMeta } from '../models/post-editor';

// currentIndex is a number of variation index, starting from 1, we don't use 0 index.
export const getVariationIndexes = (
  textsCount: number,
  mediaCount: number,
  total: number,
  currentIndex: number
): [number, number] => {
  const getCurrentIndex = (i: number, length: number): number => {
    const ceil = Math.floor(i / length);
    return i - ceil * length;
  };
  const aArr = Array(textsCount)
    .fill(1)
    .map((_, i) => i + 1); // 1,2,3
  const bArr = Array(mediaCount)
    .fill(1)
    .map((_, i) => i + 1); // 1,2
  const merged = Array(total)
    .fill(1)
    .map((_, i) => {
      const aIndex = i + 1 > aArr.length ? aArr[getCurrentIndex(i, aArr.length)] : aArr[i] ?? null;
      const bIndex = i + 1 > bArr.length ? bArr[getCurrentIndex(i, bArr.length)] : bArr[i] ?? null;
      return [aIndex, bIndex] as [number, number];
    });
  return merged[currentIndex - 1];
};

export const getGreatestCommonDivisor = (a: number, b: number): number => (!b ? a : getGreatestCommonDivisor(b, a % b));

export const calculateVariations = (
  texts: EditorText[],
  medias: MediaTypePostEditorState[],
  varyMedia: null | PostMultiMediaAttachMode,
  currentVariationIndex = 1
): Omit<VariationMeta, 'prevPostedCount'> => {
  const total =
    medias.length > 1 && varyMedia === PostMultiMediaAttachMode.ALTERNATE
      ? texts.length * (medias.length / getGreatestCommonDivisor(texts.length, medias.length))
      : texts.length;
  if (currentVariationIndex <= total) {
    if (varyMedia === PostMultiMediaAttachMode.ALTERNATE) {
      const [textVariationIndex, mediaVariationIndex] = getVariationIndexes(
        texts.length,
        medias.length,
        total,
        currentVariationIndex
      );
      return {
        currentVariationIndex,
        total,
        textVariationIndex,
        mediaVariationIndex
      };
    } else if (varyMedia === PostMultiMediaAttachMode.MULTIPLE) {
      return {
        currentVariationIndex,
        total,
        textVariationIndex: currentVariationIndex,
        mediaVariationIndex: null
      };
    }
  }
  return {
    currentVariationIndex,
    total: 0,
    textVariationIndex: null,
    mediaVariationIndex: null
  };
};
